import { Link } from 'react-router-dom';
import { PATHS } from 'Utils/PagePaths';

export const data = [
  {
    title: "Introduction",
    level: 1,
    content: "Common Formats for Event Reporting - Community Pharmacy Version 1.0 (CFER-CP V1.0) is one module in a series of Common Formats released by AHRQ. The module is primarily designed for use in the community pharmacy environment to gain enhanced understanding about the circumstances surrounding patient safety concerns in that setting. The framework applies a structured approach to the analysis of all community pharmacy events.",
  },
  {
    level: 1,
    title: "Collect Data",
    content: <><strong>Collect Data from Providers</strong>: Prepare your patient safety event information using the Community Pharmacy Version 1.0 Common Format. The resources provided below including the Data Dictionary, Users' Guide, and Flow Charts, will help you understand required data elements, answer values, and validation rules before you create your submission files.</>,
    children: [
      {
        title: "Key Resources",
        level: 2,
        cards: [824, 864, 825, 826, ]
      },
    ]
  },
  
  {
    level: 1,
    title: "Submit Data",
    content: <><strong>Submit Data to NPSD</strong>: Submit your patient safety event data to the PSOPPC using the Community Pharmacy Version 1.0 Common Format. These resources walk you through the process for both CDA XML and Alternate Data Submission formats, including an Implementation Guide, Resources Workbook, and Sample Files. For more information before you get started, see the <Link to={PATHS.public['Submit Data']}>Submit Data</Link> page.</>,
    children: [
      {
        title: "Key Resources",
        level: 2,
        cards: [827, 830, 2042, 846, 847, 1312, 2065, 1309, 828, 829, 831, 1309 ],
      },
    ]
  },

]